appSocial.service('ContextMenuService', [
    function () {
        class ContextMenuService {
            constructor() {
                this.instances = [];

                $(document).click((event) => {
                    //event.preventDefault();
                    // skip hiding when clicking inside the directive
                    if ($(event.target).attr('data-instance-id') || $(event.target.parentNode).attr('data-instance-id')) {
                        return;
                    }
                    // otherwise - hide all
                    this.instances.forEach(item => this.hide(item));
                });
            }

            /**
             * @param {Menu} menu
             */
            register(menu) {
                this.instances.push(menu);
                menu.wrapper.css({display: 'none'});
            }

            /**
             * @param {Menu} menu
             */
            remove(menu) {
                this.hide(menu);
                _.remove(this.instances, {id: menu.id});
            }

            /**
             * @param {Menu} menu
             */
            show(menu) {
                if (menu.isOpen) {
                    menu.wrapper.css({display: "none"})
                    menu.isOpen = false;
                } else {
                    // close all other instances except this one
                    this.instances
                        .filter(item => item.id !== menu.id)
                        .forEach(item => this.hide(item));

                    const top = (menu.config && menu.config.top && typeof menu.config.top === 'function')
                        ? menu.config.top(menu)
                        : (menu.portal.offset().top - 15) + 'px';

                    const right = (menu.config && menu.config.right && typeof menu.config.right === 'function')
                        ? menu.config.right(menu)
                        : '1%';

                    const left = (menu.config && menu.config.left && typeof menu.config.left === 'function')
                        && menu.config.left(menu);

                    const bottom = (menu.config && menu.config.bottom && typeof menu.config.bottom === 'function')
                        && menu.config.bottom(menu);

                    menu.wrapper.css({
                        position: "fixed",
                        display: "flex",
                        right,
                        top,
                        left,
                        bottom
                    });
                    menu.isOpen = true;
                }
            }

            /**
             * @param {Menu} menu
             */
            hide(menu) {
                menu.wrapper.css({display: "none"})
                menu.isOpen = false;
            }

        }

        return new ContextMenuService();
    }
]);

/**
 * @typedef {Object} MenuConfig
 * @property {Function | number | string | null} top
 * @property {Function | number | string | null} left
 * @property {Function | number | string | null} right
 * @property {Function | number | string | null} bottom
 */

/**
 * @typedef {Object} Menu
 * @property {number} id
 * @property {jQuery} portal
 * @property {jQuery} wrapper
 * @property {boolean} isOpen
 * @property {MenuConfig} config
 */
